<template>
  <button :class="this.styleClass" v-on:click="getFile()">
    <slot name="body" style="width: fit-content" v-bind:downloading="this.isDownloading">
      <div v-if="!isDownloading">
        {{ label || name }}
      </div>
      <b-spinner
        v-if="isDownloading"
        class="mr-1"
        variant="primary"
      />
    </slot>
  </button>
</template>

<script>

import { mapActions } from 'vuex';

export default {
  data() {
    return {
      isDownloading: false
    };
  },
  components: {},
  mixins: [],
  watch: {},
  computed: {},
  methods: {
    ...mapActions('Dnts', [
      'downloadPrivateFile'
    ]),
    async getFile() {
      if (this.isDownloading) {
        return;
      }
      try {
        this.isDownloading = true;
        await this.downloadPrivateFile({
          path: this.path,
          nombre: this.name,
          descargable: this.force
        });
      } finally {
        this.isDownloading = false;
      }
    }
  },
  props: {
    path: {
      type: String,
      required: true,
      default: () => ''
    },
    name: {
      type: [String],
      required: true,
      default: () => ''
    },
    force: {
      type: String,
      required: false,
      default: ''
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    styleClass: {
      type: String,
      required: false,
      default: 'btn btn-secondary'
    }
  }
};
</script>
